import { useMemo } from 'react';
import { uuidv4 } from '@chronos/utils';
import BoardMenuItem from './BoardMenuItem';

const Boards = ({ boards, handleClick }) => {
  const boardsWithUniqKey = useMemo(
    () => boards.map((board) => ({ ...board, uniqKey: uuidv4() })),
    [boards]
  );

  return boardsWithUniqKey.map(({ uniqKey, ...board }) => (
    <BoardMenuItem
      key={uniqKey} // need to use uniqKey so that the indicators blink simultaneously
      onClick={handleClick}
      board={board}
    />
  ));
};

export default Boards;
